import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, forwardRef, createElement } from "react";
import { Spinner } from "../../Spinner.js";
import { toSchemeClass } from "../../../utils/toSchemeClass.js";
import { useClassNamePrefix } from "../../../auxiliary/useClassNamePrefix.js";
import { toThemeClass } from "../../../utils/toThemeClass.js";
import { toEnumViewClass } from "../../../utils/toEnumViewClass.js";
import { toStateClass } from "../../../utils/toStateClass.js";
import { toViewClass } from "../../../utils/toViewClass.js";
import { toEnumClass } from "../../../utils/toEnumClass.js";
const AnchorButton = memo(
  forwardRef((props, ref) => {
    return /* @__PURE__ */ jsx(BaseButton, { ...props, ref, Component: "a" });
  })
);
AnchorButton.displayName = "AnchorButton";
const Button = memo(
  forwardRef((props, ref) => {
    return /* @__PURE__ */ jsx(BaseButton, { ...props, ref, Component: "button" });
  })
);
Button.displayName = "Button";
const BaseButton = memo(
  forwardRef((props, ref) => {
    const { Component, intent, size, flow, distinction, elevation, justification, loading, active, bland, children, scheme, ...rest } = props;
    if (props.disabled === true) {
      rest["aria-disabled"] = true;
      rest["tabIndex"] = -1;
    }
    if (props.Component === "button") {
      rest.type = props.type !== void 0 ? props.type : "button";
    }
    const prefix = useClassNamePrefix();
    const themeIntent = !props.disabled ? intent : "default";
    const attrs = {
      className: classNames(
        rest.className,
        `${prefix}button`,
        toThemeClass(props.distinction === "default" ? null : themeIntent, themeIntent),
        toSchemeClass(!props.disabled ? scheme : void 0),
        toEnumViewClass(size),
        toEnumViewClass(props.disabled ? "default" : distinction),
        toEnumViewClass(flow),
        toEnumViewClass(justification, "justifyCenter"),
        toStateClass("loading", loading),
        toStateClass("active", active),
        toViewClass("bland", bland),
        toEnumClass("elevation-", elevation)
      ),
      ref,
      ...props.disabled ? {
        href: null,
        onClick: null
      } : void 0
    };
    const content = /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: `${prefix}button-content`, children }),
      loading && /* @__PURE__ */ jsx("span", { className: `${prefix}button-spinner`, children: /* @__PURE__ */ jsx(Spinner, {}) })
    ] });
    return createElement(Component, { ...rest, ...attrs }, content);
  })
);
BaseButton.displayName = "BaseButton";
export {
  AnchorButton,
  BaseButton,
  Button
};
//# sourceMappingURL=Button.js.map
